import type { SomeAdditionalSearchableFeature } from "../types";

export const parseAdditionalSearchableFeature = (additionalSearchableFeature: SomeAdditionalSearchableFeature) => {
  return additionalSearchableFeature((info) => {
    return info;
  });
};
